import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Box from "../Box";
import Button from "../Button";
import UploadFile from "../Events/UploadFile";
import Selectfield from "../Merchant/Selectfield";
import Textfield from "../Merchant/Textfield";
import Textarea from "../Textarea";
import { ActiveDeactive, StyledStatus } from "../../pages/AddPark";
import Toggle from "../Toggle";

interface Props {
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  onRemove: () => void;
  value: {
    title: string;
    category: string;
    body: string;
    deepLinkId: string;
  };
  error: {
    title: string;
    body: string;
    deepLinkId: string;
  };
  uploadedImage: any;
  category: (
    | { label: string; value: string }
    | { label: string; value: number }
  )[];
  onSubmit: () => void;
  onEnableDLChange: any;
  enableDL: boolean;
  typeList: any;
}

const PushNotificationFormContainer = ({
  onSubmit,
  onChange,
  onRemove,
  value,
  error,
  uploadedImage,
  category,
  enableDL,
  onEnableDLChange,
  typeList,
}: Props) => {
  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="title"
                label="Title"
                placeholder="Subject"
                onChange={onChange}
                value={value.title}
                required
                helperText={error["title"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="category"
                label="Category"
                onChange={onChange}
                data={category}
                value={value.category}
                disabled={false}
                required={false}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textarea
                name="body"
                value={value.body}
                placeholder="Message"
                label="Message"
                error={error.body ? true : false}
                onChange={onChange}
                required
              />
              {error.body && <Error>{error.body}</Error>}
            </FieldWrapper>
            <FieldWrapper>
              <UploadFile
                name="imageUrl"
                label="Upload your image"
                onChange={onChange}
                uploadedImage={uploadedImage}
                onRemove={onRemove}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontSize: "14px", fontWeight: 700 }}>
                  Enable deep linking for this notification
                </div>
                <div>
                  <StyledStatus>
                    <Toggle
                      isDisabled={value.category === "home"}
                      uniqueName={"enableDL"}
                      isChecked={enableDL}
                      onChange={onEnableDLChange}
                    />
                    <ActiveDeactive status={enableDL}>
                      {enableDL ? "ON" : "OFF"}
                    </ActiveDeactive>
                  </StyledStatus>
                </div>
              </div>
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  fontStyle: "italic",
                }}
              >
                When the deep link feature is enabled, users who click the
                notification will be automatically redirected to the specified
                URL destination. The target screen/location will be determined
                by the URL configured
              </div>
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="deepLinkId"
                label="Deeplink to"
                onChange={onChange}
                value={value?.deepLinkId}
                required={
                  enableDL && value.category !== "" && value.category !== "home"
                }
                helperText={error["deepLinkId"]}
                disabled={!enableDL || value.category === "home"}
                data={[{ value: "", label: "Select Deeplink to" }, ...typeList]}
              />
            </FieldWrapper>
          </FormRow>
          <ActionRow>
            <FieldWrapper />
            <ButtonWrapper>
              <Button
                color={Colors.red}
                variant="filled"
                label="Send"
                onClick={onSubmit}
                width="9.7rem"
              />
            </ButtonWrapper>
          </ActionRow>
        </FormWrapper>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default PushNotificationFormContainer;
